// Organization configuration used by shared components (e.g. volunteer waiver)
// so the same React build can be deployed to Yugal Kunj / RMS sites or to the
// Harmony Youth Center / Flowery Grove Montessori site.

export const getOrganizationConfig = () => {
  const hostname =
    (typeof window !== 'undefined' && window.location && window.location.hostname)
      ? window.location.hostname.toLowerCase()
      : '';

  const envOrg = (process.env.REACT_APP_ORGANIZATION_TYPE || '').toLowerCase();

  const isHycSite =
    envOrg === 'hyc' ||
    hostname.includes('hyc') ||
    hostname.includes('harmony') ||
    hostname.includes('flowerygrove') ||
    hostname.includes('flowery-grove') ||
    hostname.includes('flowerygrovemontessori') ||
    hostname.includes('flowery');

  if (isHycSite) {
    return {
      name: 'Harmony Youth Center',
      subtitle: 'Flowery Grove Montessori',
      fullName: 'Harmony Youth Center / Flowery Grove Montessori',
      shortName: 'HYC',
      address: '2769 Duluth Highway, Duluth, GA 30096',
    };
  }

  return {
    name: 'Radha Madhav Society',
    subtitle: '',
    fullName: 'Radha Madhav Society',
    shortName: 'RMS',
    address: '2769 Duluth Highway, Duluth, GA 30096',
  };
};
